import React from "react";

const RequiredField = () => {
  return (
    <span className="delete-color">*</span>
  )
};

export default RequiredField;